import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Checkbox, TableRow, TableCell, IconButton } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { convertLocalTime } from 'src/utils/convertTime';

import Iconify from 'src/components/iconify';

function TagRow({
  tag,
  isItemSelected,
  handleClick,
  handleOpenMenu,
  onRowClick,
  showCheckBox,
  showOptions,
  showDeptAndCreator,
}) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const showContextCols = showDeptAndCreator;

  return (
    <TableRow
      selected={isItemSelected}
      sx={{ cursor: 'pointer' }}
      hover
      onClick={() => onRowClick(tag)}
    >
      {showCheckBox && (
        <TableCell padding="checkbox">
          <Checkbox
            checked={isItemSelected}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => handleClick(event, tag.id)}
          />
        </TableCell>
      )}

      <TableCell sx={{ fontSize: isSmallScreen && '0.65rem' }}>#{tag.id}</TableCell>

      <TableCell sx={{ fontSize: isSmallScreen && '0.65rem' }}>{tag.name}</TableCell>

      <TableCell sx={{ fontSize: isSmallScreen && '0.65rem' }} align="left">
        {tag.description || '-'}
      </TableCell>

      {showContextCols && (
        <>
          <TableCell align="center" sx={{ fontSize: isSmallScreen && '0.65rem' }}>
            {tag.department || t('pages.statusPage.noDepartment')}
          </TableCell>
          <TableCell align="center" sx={{ fontSize: isSmallScreen && '0.65rem' }}>
            {tag.createdBy || '—'}
          </TableCell>
        </>
      )}

      <TableCell align="center" sx={{ fontSize: isSmallScreen && '0.65rem' }}>
        {format(convertLocalTime(new Date(tag.createdAt)), 'dd/MM/yyyy HH:mm:ss')}
      </TableCell>

      <TableCell align="center" sx={{ fontSize: isSmallScreen && '0.65rem' }}>
        {tag.updatedAt
          ? format(convertLocalTime(new Date(tag.updatedAt)), 'dd/MM/yyyy HH:mm:ss')
          : '-'}
      </TableCell>

      {showOptions && (
        <TableCell
          align="center"
          sx={{ position: 'sticky', right: 0, backgroundColor: 'background.paper' }}
        >
          <IconButton
            color="inherit"
            onClick={(event) => {
              event.stopPropagation();
              handleOpenMenu(event, tag);
            }}
          >
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  );
}

TagRow.propTypes = {
  tag: PropTypes.object,
  isItemSelected: PropTypes.bool,
  handleClick: PropTypes.func,
  handleOpenMenu: PropTypes.func,
  onRowClick: PropTypes.func,
  showCheckBox: PropTypes.bool,
  showOptions: PropTypes.bool,
  showDeptAndCreator: PropTypes.bool,
};

export default TagRow;
